@if (
    feeConfig.feeConfigs.entryFeeInfo?.unpaidAmountWithVat &&
    feeConfig.feeConfigs.regularEntryFeeConfig.entryFeeType !== EFeeType.PROPORTIONAL
) {
    <div class="fee-container">
        <div class="fee-layout">
            <svg-icon
                src="assets/icons/money-bank.svg"
                class="fee-icon"
            ></svg-icon>
            <div class="info-wrapper">
                <div class="header">
                    {{ 'moneyAndTransactions.oneTimeFee' | translate }}
                </div>
                <div class="desc">
                    {{ 'moneyAndTransactions.oneTimeDescPart1' | translate }}
                  <b>{{ 'moneyAndTransactions.oneTimeDescBold' | translate }}</b>{{ 'moneyAndTransactions.oneTimeDescPart2' | translate }}
                </div>

                @let entryfeeConfig = feeConfig.feeConfigs.regularEntryFeeConfig;
                @if (entryfeeConfig) {
                    <div class="fee-row">
                        <div class="fee-label">
                            {{ 'moneyAndTransactions.totalEntryFeeVariant' | translate }}
                        </div>
                        <div class="fee-value">
                            <div class="value-wrapper">
                                @if (feeConfig.feeConfigs.entryFeeInfo && feeConfig.feeConfigs.entryFeeInfo!.totalEntryFee > 0) {
                                    <liberro-fee-info-tooltip [feeType]="entryfeeConfig.entryFeeType"></liberro-fee-info-tooltip>
                                }
                                {{ 'moneyAndTransactions.feeTypes.' + entryfeeConfig.entryFeeType | translate }}
                            </div>
                        </div>
                    </div>
                }
                <div class="fee-row">
                    <div class="fee-label">
                        {{ 'moneyAndTransactions.totalEntryFeeAmount' | translate }}
                    </div>
                    <div class="fee-value">
                        <div class="value-wrapper">
                            <svg-icon
                                src="assets/icons/bwm-question-circle.svg"
                                class="question-mark-tooltip question-mark-cursor"
                                nz-tooltip
                                autoCloseOnScroll
                                mobileExplainTooltipSheet
                                [nzTooltipTitle]="totalEntryFeeAmountTooltip"
                                [nzTooltipVisible]="tooltipVisible()"
                                (nzTooltipVisibleChange)="tooltipToggle($event)"
                                (click)="tooltipToggle(!tooltipVisible())"
                                nzTooltipOverlayClassName="basic"
                                [svgStyle]="{ 'height.px':16 }"
                            ></svg-icon>
                            <ng-template #totalEntryFeeAmountTooltip>
                                <liberro-tooltip-content (closeClick)="onTooltipHide($event)">
                                    <div tooltipHeader>
                                        <div class="tooltip-header">
                                            {{ 'moneyAndTransactions.entryFee' | translate }}
                                        </div>
                                    </div>
                                    <div tooltipContent>
                                        <div class="tooltip-desc">
                                            {{ 'moneyAndTransactions.totalEntryFeeAmountTooltip' | translate }}
                                        </div>
                                    </div>
                                </liberro-tooltip-content>
                            </ng-template>

                            {{ feeConfig.feeConfigs.entryFeeInfo?.totalEntryFee ?? 0 | price:'CZK' }}
                        </div>
                         @if (feeConfig.feeConfigs.entryFeeConfig?.entryDiscountRegular) {
                            <div class="fee-discount">
                                {{ 'moneyAndTransactions.includingSalePart1' | translate }}
                                {{ feeConfig.feeConfigs.entryFeeConfig?.entryDiscountRegular ?? 0 | price:'CZK' }}
                                {{ 'moneyAndTransactions.includingSalePart2' | translate }}
                            </div>
                         }
                    </div>
                </div>
                <div class="fee-row">
                    <div class="fee-label">
                        {{ 'moneyAndTransactions.alreadyPaid' | translate }}
                    </div>
                    <div class="fee-value">
                        {{ (feeConfig.feeConfigs.hasVat ? feeConfig.feeConfigs.entryFeeInfo?.entryFeeAlreadyPaidWithVat : feeConfig.feeConfigs.entryFeeInfo?.entryFeeAlreadyPaid) ?? 0 | price:'CZK' }}
                        @if (feeConfig.feeConfigs.entryFeeInfo?.vatAlreadyPaid) {
                            <div class="fee-discount">
                                {{ 'moneyAndTransactions.alreadyPaidVATPart1' | translate }}
                                {{ feeConfig.feeConfigs.entryFeeInfo?.entryFeeAlreadyPaid ?? 0 | price:'CZK' }}
                                {{ 'moneyAndTransactions.alreadyPaidVATPart2' | translate }}
                                {{ feeConfig.feeConfigs.entryFeeInfo?.vatAlreadyPaid ?? 0 | price:'CZK' }}
                                {{ 'moneyAndTransactions.alreadyPaidVATPart3' | translate }}
                            </div>
                         }
                    </div>
                </div>
                <div class="fee-row">
                    <div class="fee-label">
                        @if (feeConfig.feeConfigs.hasVat) {
                            {{ 'moneyAndTransactions.unpaidWithVat' | translate }}
                        } @else {
                            {{ 'moneyAndTransactions.unpaidWithoutVat' | translate }}
                        }
                    </div>
                    <div class="fee-value">
                        {{ feeConfig.feeConfigs.entryFeeInfo?.unpaidAmountWithVat ?? 0 | price:'CZK' }}
                    </div>
                </div>

                @let entryFeeInfo = feeConfig.feeConfigs.entryFeeInfo;
                @if (entryFeeInfo && (feeConfig.feeConfigs.entryFeeConfig?.entryFee ?? 0) > 0) {
                    <div class="fee-additional-info">
                        {{ 'moneyAndTransactions.entryFeeInfoPart1' | translate }}
                        <b>{{ 'moneyAndTransactions.entryFeeInfoPart2Bold' | translate }}
                        {{ entryFeeInfo.totalRegularAmount | price:'CZK' }}</b>{{ 'moneyAndTransactions.entryFeeInfoPart3' | translate }}<b>{{ 'moneyAndTransactions.entryFeeInfoPart4Bold' | translate }}
                        {{ entryFeeInfo.totalTargetRegularAmount | price:'CZK' }}{{ 'moneyAndTransactions.entryFeeInfoPart5Bold' | translate }}
                        {{ entryFeeInfo.remainingAmountToReachTargetActual | price:'CZK' }}</b>{{ 'moneyAndTransactions.entryFeeInfoPart6' | translate }}
                    </div>
                }
            </div>
        </div>
    </div>
}
